import React from "react";
import { useViewer } from "../../../../app/hooks/hooks";
import classes from "./MeasureButton.module.css";
import { ReactComponent as IconMeasure } from "../Buttons/icons/icon-measure.svg";

function MeasureButton() {
    const viewer = useViewer();
    const measureHandle = () => {
        if (!viewer) return;
        viewer.utils.dimentionsUtils.toggleDimentionsActive();
    };
    return (
        <button
            className={[
                classes.MeasureButton,
                viewer?.utils.dimentionsUtils.active ? classes.clicked : "",
            ].join(" ")}
            onClick={measureHandle}
        >
            <IconMeasure
                className={[
                    classes.icon,
                    viewer?.utils.dimentionsUtils.active
                        ? classes.clickedIcon
                        : "",
                ].join(" ")}
            />
        </button>
    );
}

export default MeasureButton;
